export default __webpack_public_path__ + "static/media/transfer.b0c9f712.svg";